import React from 'react';
import { ButtonElement as ButtonType } from '../../types/element.types';

interface ButtonElementProps {
  element: ButtonType;
}

/**
 * Button Element Renderer
 */
const ButtonElement: React.FC<ButtonElementProps> = ({ element }) => {
  const { link, openInNewTab } = element.settings || {};

  const buttonContent = (
    <button
      className="button-element"
      style={element.styles as React.CSSProperties}
      onClick={(e) => {
        if (!link) {
          e.preventDefault();
        }
      }}
    >
      {element.content}
    </button>
  );

  if (link) {
    return (
      <a
        href={link}
        target={openInNewTab ? '_blank' : '_self'}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
        style={{ textDecoration: 'none' }}
      >
        {buttonContent}
      </a>
    );
  }

  return buttonContent;
};

export default ButtonElement;

